import Phaser, {
    Display,
    Loader
} from 'phaser'

import gsap from "gsap";


let bubbleGS;
let walkInGS;
//let bubbleOutGS;
let speechContainer;
let guide;
let guideImg;
let sounds;
let parent;
let gameScale;
let armGS;
let arm;
let domText;
let tlArr;
//let textGS;

export default class GuideAnimate extends Phaser.Scene {
    constructor() {
        super('guideAnimate')
    }

    preload() {

    }
    init() {
        //What are we animating from guide.js?
        speechContainer = arguments[0].speechContainer;
        guide = arguments[0].guide;
        guideImg = arguments[0].guideImg;
        domText = arguments[0].domText;
        tlArr = [];
    }
    create() {
        parent = this.scene.get('guide');
        gameScale = this.registry.get('scaleIt');
        //play some sound effects
        sounds = this.scene.get('sounds');
        //timeline for bubble coming in animation

        this.createBubbleIn();

        // this.createBubbleOut();

        //listen for guide class to be paused and pause as well
        //this.events.on('pause', this.paused, this);
        this.scene.get('guide').events.on('pause', this.paused, this);
        this.scene.get('guide').events.on('resume', this.resumed, this);
    }

    paused() {
        for (let index = 0; index < tlArr.length; index++) {
            tlArr[index].pause();
        }
        this.scene.pause('guideAnimate');
        parent.removeBubble();
    }

    resumed() {
        this.scene.resume('guideAnimate');
    }


    createBubbleIn() {
        bubbleGS = gsap.timeline({
            onReverseComplete: parent.removeBubble,
            defaults: { // children inherit these defaults
                duration: 0.5,
                ease: "back.out"
            }
        });

        //What to do to bring in the bubble
        bubbleGS.from(speechContainer, {

                scale: 0,

                // @ts-ignore
                onStart: sounds.playPop,
                //    onComplete: parent.textShowHide
            })

            .from(domText, {
                duration: 0.1,
                alpha: 0.01
            }, 0.19)
        bubbleGS.pause(0);

        tlArr.push(bubbleGS);
    }

    /*  createBubbleOut() {
          //How to animate the bubble out
          bubbleOutGS = gsap.timeline({
              onComplete: parent.removeBubble,
              defaults: { // children inherit these defaults
                  duration: 0.25, //0.25,
                  ease: 'back.in'
              },

          });
          bubbleOutGS.to(speechContainer, {
              alpha: 0,
              scale: 0
          }).to(domText, {
              duration: 0.1,
              alpha: 0.01

          }, 0)
          bubbleOutGS.pause(0);

      }*/

    setupArm(obj) {
        arm = obj;
        let armRotate = -1.5;

        if (!arm.flipX) armRotate = armRotate * -1;
        armGS = gsap.timeline({});
        armGS.to(arm, {
            duration: 1.2,
            rotation: armRotate,
            ease: 'back.out'
        })
        armGS.pause(0);
        //tlArr.push(armGS);
    }


    walkIn(f) {

        //If it doesn't exist yet fill in tweens	
        let defaults = {
            duration: 0.2,
            ease: "sine.out"
        };
        if (f == null) {
            walkInGS = gsap.timeline({
                defaults: defaults
            });
        } else {
            walkInGS = gsap.timeline({
                onComplete: f,
                defaults: defaults
            });
        }

        guide.visible = true;
        this.scene.bringToTop('guide');
        let dis = 9 * gameScale;
        let wid = guideImg.displayWidth;

        //if it comes in from the left, just move it the width off screen
        let newX = guideImg.displayWidth;
        // needs to be moved - - 
        if (guideImg.flipX) newX = newX * -1;

        walkInGS.to(guide, {
                y: '+=' + dis,
                ease: 'sine.in'
            })
            .to(guide, {
                y: '-=' + dis
            })
            .to(guide, {
                y: '+=' + dis,
                ease: 'sine.in'
            })
            .to(guide, {
                y: '-=' + dis
            })

            .from(guide, {
                duration: 0.2 * 4,
                x: '-=' + newX,
                ease: 'none'

            }, 0);

        tlArr.push(walkInGS);
    }
    raiseArm(reverse = false) {
        if (reverse) {
            armGS.reverse();
        } else {
            armGS.restart();
        }
    }



    animateBubbleIn() {
        let speaker = arguments[0].speaker;
        //speechContainer.scale = 1;
        bubbleGS.restart();
        //speechContainer.alpha = 1;

        speechContainer.setVisible(true);
        //only marama raises her arm
        // the arm is only visible in the profile texture
        // only raise the arm once
        if (!arm) return;
        if (speaker == 'marama' && arm.visible && arm.rotation == 0) {
            this.raiseArm();
        }
    }

    animateBubbleOut() {
        if (arm) {
            this.raiseArm(true);
        }
        //bubbleOutGS.restart();

        bubbleGS.reverse();
    }
}